export default function LowBar() {
  return (
    <div className="lowbar">
      <p>About</p>
      <p>Hire</p>
      <p>Services</p>

      <p>Contact</p>
    </div>
  );
}
